import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { DocumentsList } from './components/DocumentList'

const documentsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Documents',
    path: '/documents/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const DocumentPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=':id'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Documents'}></DocumentTitle>
              <PageTitle breadcrumbs={documentsBreadcrumbs}>Documents</PageTitle>
              <DocumentsList />
            </>
          }
        />
        <Route index element={<Navigate to='/documents/list' />} />
      </Route>
    </Routes>
  )
}

export default DocumentPage
